import { useTran } from "@/hooks";
import { Switch } from "@/components/ui/switch";

const RequiredToggles = ({ required, onRequiredChange }) => {
  const { t } = useTran();

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-4 rounded-radius border border-border bg-muted/40 p-3">
        <div>
          <p className="text-xs font-semibold text-foreground">
            {t("Required question")}
          </p>
          <p className="text-[11px] text-muted-foreground">
            {t("Respondents must provide an answer.")}
          </p>
        </div>
        <Switch
          checked={Boolean(required)}
          onCheckedChange={onRequiredChange}
        />
      </div>
    </div>
  );
};

export default RequiredToggles;
